import React from 'react';
import TbodyTableManifiesto from './tbody';
import TheadTableManifiesto from './thead';

const TableManifiesto = (props) => {
  return (
    <div className="mx-4 mt-4 overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
      <table className="w-full table-auto text-sm">
        <TheadTableManifiesto />
        <TbodyTableManifiesto />
      </table>
    </div>
  );
};

export default TableManifiesto;
